module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAYAAAByUDbMAAABEUlEQVQ4T52Tiw3CMAxEr5vAJMAkwCTAJLAJMAlsUvQiX2VVaRphCQmK/Xr+3KD+2Evis5P0jbK3pIcRQwdrI+keINJfUQOYAHbjBT2wMYrOWUU8u0q6hNLDGgxFJ0nb1Nq8GRSS92rBSHpKaimiPdQVhS2YW6jluHVU+v9PC4Yq4lBZkl9kZaQ8WzDmwCZrsNoRLMKAfGLoDL8nxpoygwC0tphfwMbvc9g/INc8MmwJZBthock6Iasoiu+DYS1F3pzbmtuJ39xisVNLEYBjuIACTE5Qg8kBGV4Ojnuilfmw/dyK1qw3wWrH6aPlMIlJwdKdWFmGZasA6D3aqjJgQJhJbYOLB5xnlreUPddz/SXnBzZZR8zquV+bAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Group.png
// module id = oBap
// module chunks = 2